<div
  class="flex flex-row w-90-ns center ph5 mh4 items-center justify-center mb5 pv4-ns"
>
  <a
    [jbSitemapLinker]="mobileLink"
    class="flex mv3 items-center no-underline royal-blue fill-royal-blue mobile-alert-label"
  >
    <jb-icon
      [ngClass]="{ pt5: lowerLabel }"
      class="dib pointer"
      name="app"
      width="1.5em"
      height="1.5em"
    >
    </jb-icon>
    <span [ngClass]="{ pt5: lowerLabel }" class="body tc b royal-blue">
      {{ mobileAlertCopy }}
    </span>
  </a>
</div>
